import ExerciseProperties from './ExerciseProperties';

export default ExerciseProperties;
